import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Modal from '../Modal/Modal';
import ModalBody from '../Modal/ModalBody';
import ModalButtons from '../Modal/ModalButtons';
import Paragraph from '../Paragraph/Paragraph';
import { pxToRem } from '../../assets/styles/helper';

const Message = styled(Paragraph)`
  margin-bottom: ${pxToRem(20)};
`;

const ErrorCode = styled(Paragraph)`
  font-weight: 600;
  margin-bottom: ${pxToRem(4)};
`;

const Phone = styled(Paragraph)`
  margin-bottom: 0;
`;

const CustomerServiceInfoModal = ({ isOpen, close, phoneNumber }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      size="sm"
      title={t('support.contactCustomerServiceTitle')}
      close={close}
      closeIconVisible
    >
      <ModalBody>
        <Message labelColor>
          {t('support.contactCustomerServiceMessage')}
        </Message>
        <ErrorCode labelColor>
          {t('support.errorCodeLabel')}: {t('support.defaultErrorCode')}
        </ErrorCode>
        <br />
        <Phone labelColor>
          {phoneNumber} {t('support.tollFreeSuffix')}
        </Phone>
        <ModalButtons
          isVertical
          marginTop
          showOnlyPrimary
          primaryButtonProps={{
            onClick: close,
            label: t('common.ok'),
          }}
        />
      </ModalBody>
    </Modal>
  );
};

CustomerServiceInfoModal.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
  phoneNumber: PropTypes.string.isRequired,
};

export default CustomerServiceInfoModal;
